import { isEmpty } from 'lodash'
import analytics from '@adc/analytics'
const LOGIN = 'login'
const GTM_AUTH_LOGIN = 'account-login'
const GTM_AUTH_SIGNUP = 'account-signup'

// signup errors come through an array normally
const signupErrorMessage = authError => {
  return !isEmpty(authError.errors)
    ? authError.errors.join(', ')
    : authError.error || 'Unknown error'
}

export const trackAuthModalToggle = authType => {
  gtmAuthModalOpen({ modalTab: authType })
}

export const gtmAuthFailure = error => {
  const { intent } = error
  const event = error.authType === LOGIN ? GTM_AUTH_LOGIN : GTM_AUTH_SIGNUP
  const status = 'fail'
  const reasonFailed = error.error_code
    ? error.error_code
    : signupErrorMessage(error)
  analytics.track(event, { status, reasonFailed, intent })
}

export const gtmAuthModalOpen = extraProps => {
  analytics.track('modal-start', extraProps)
}

export const gtmAuthSuccess = (event, user, extraProps = {}) => {
  analytics.track(event, {
    status: 'success',
    ...extraProps,
    ...analytics.standardTracking.user(user),
  })
}

export const gtmNewUserOnboardingInit = skippable => {
  analytics.track('post-account-modal', {
    testId1: '10001',
    testVariant1: skippable ? 'a1' : 'b1',
  })
}

export const gtmOnboardingDrawer = () => {
  analytics.track('side-modal')
}

export const gtmPreferencesNudge = () => {
  analytics.track('preferences-nudge')
}

export const gtmPurchaseProfileNudge = () => {
  analytics.track('purchase-profile-nudge')
}

export const gtmNewUserOnboardingClick = label => {
  analytics.track('onboarding-option', {
    label,
  })
}

export const gtmNewUserOnboardingExit = step => {
  analytics.track('onboarding-exit', {
    step,
  })
}

export const gtmOnboardingDrawerExit = () => {
  analytics.track('drawer-exit')
}

export const gtmLiveChatWidget = () => {
  analytics.track('live-chat-widget')
}
